import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { workshopRegistrationsApi } from "./client";

export const workshopRegistrationKeys = {
  events: ["workshop-events"] as const,
  list: (query: Record<string, unknown>) =>
    ["workshop-registrations", query] as const,
};

export function useWorkshopEventsQuery() {
  return useQuery({
    queryKey: workshopRegistrationKeys.events,
    queryFn: () => workshopRegistrationsApi.listEvents(),
  });
}

export function useWorkshopRegistrationsQuery(
  query: Record<string, string | number | undefined>,
) {
  return useQuery({
    queryKey: workshopRegistrationKeys.list(query),
    queryFn: () => workshopRegistrationsApi.listRegistrations(query),
  });
}

export function useUpdateWorkshopRegistrationMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      body,
    }: {
      id: string;
      body: { status?: string; adminNotes?: string | null };
    }) => workshopRegistrationsApi.updateRegistration(id, body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["workshop-registrations"] });
    },
  });
}
